// extracted by mini-css-extract-plugin
module.exports = {"container":"PDgVcahUajG2bg97lKN8z","copyEmailsList":"_2WJBMZ5DMUPlHjF5FY2jmM","item":"_1X1nkXsyN824Oqkz7vuPs4","dot":"_1NNtg6NIPZubMOn2UHZPl3"};